import React, { useContext, useEffect, useState } from "react";
import { HierarchicalTree, SnapConstraints, DiagramComponent, Inject, DataBinding, DiagramTools } from "@syncfusion/ej2-react-diagrams";
import { ItemDirective, ItemsDirective, ToolbarComponent, } from '@syncfusion/ej2-react-navigations';
import { DataManager } from "@syncfusion/ej2-data"
import { FaStar, FaRegStar } from "react-icons/fa";
import { Skeleton } from '@mui/material'
import { Form } from 'react-bootstrap'
import { DashboardContext } from "../../context/DashboardContext";

export default function ArvoreCapacidade({ corFavorito, cicloDemandaKey, tab }) {
    let diagramInstance;
    let toolbarEditor;

    const theme = localStorage.getItem('theme') || 'light'
    const { getArvoreCapacidades, ArvoreDeCapacidades, AdicionarGraficoFavorito } = useContext(DashboardContext)
    const [isLoading, setIsLoading] = useState(false)
    const [tipoCapacidade, setTipoCapacidade] = useState("1")

    const SAMPLE_CSS = `
            .e-diagram {
                display: block;
                ${theme == 'dark' ? "background-color: #fff;" : "background-color: #3f3f46;"}
            }

            #toolbar_diagram {
                ${theme == 'dark' ? "background-color: #fff;" : "background-color: #3f3f46;"}
            }
        `

    const retornaTipoCapacidade = (valor) => {
        if (valor === "1") {
            return (
                new DataManager(ArvoreDeCapacidades.filter(item => item.tipoSwot === "Forca" || item.tipoSwot === ""))
            )
        }
        if (valor === "2") {
            return (
                new DataManager(ArvoreDeCapacidades.filter(item => item.tipoSwot === "Fraqueza" || item.tipoSwot === ""))
            )
        }
        if (valor === "3") {
            return (
                new DataManager(ArvoreDeCapacidades.filter(item => item.tipoSwot === "Oportunidade" || item.tipoSwot === ""))
            )
        }
        if (valor === "4") {
            return (
                new DataManager(ArvoreDeCapacidades.filter(item => item.tipoSwot === "Ameaca" || item.tipoSwot === ""))
            )
        }
    }

    const dataSettings = {
        id: "key",
        parentId: "referencia",
        descricao: "descricao",
        tipo: "tipo",
        dataManager: retornaTipoCapacidade(tipoCapacidade)
    };

    const layoutSetting = { type: 'OrganizationalChart', orientation: 'LeftToRight' }

    useEffect(() => {
        if (cicloDemandaKey) {
            setIsLoading(true)
            getArvoreCapacidades(cicloDemandaKey)
                .then(() => {
                    setIsLoading(false)
                })
        }
    }, [cicloDemandaKey])

    function handleToolbarClick(args) {
        let cases = args.item.tooltipText;
        const zoomFactor = 0.2;
        switch (cases) {
            // Zoom in action
            case 'Zoom In':
                diagramInstance.zoomTo({ type: 'ZoomIn', zoomFactor });
                break;
            // Zoom Out action
            case 'Zoom Out':
                diagramInstance.zoomTo({ type: 'ZoomOut', zoomFactor });
                break;
            // Selection action
            case 'Select':
                diagramInstance.clearSelection();
                diagramInstance.drawingObject = {};
                diagramInstance.tool = DiagramTools.SingleSelect | DiagramTools.MultipleSelect;
                break;
            // Pan tool action
            case 'Pan Tool':
                diagramInstance.tool = DiagramTools.ZoomPan;
                break;
            // Reset action
            case 'Reset':
                diagramInstance.reset();
                break;
            // Fit to page action
            case 'Fit To Page':
                diagramInstance.fitToPage();
                break;
        }
    }

    useEffect(() => {
        if (diagramInstance) {
            diagramInstance.fitToPage()
        }
    }, [dataSettings]);

    return (
        <>
            <div style={{ display: 'flex', alignItems: 'end', justifyContent: 'space-between', padding: '0' }}>
                <h2 className="h2-bsc">
                    <button onClick={() => AdicionarGraficoFavorito("Árvore de Capacidades")} className='btn-grafico'>{corFavorito("Árvore de Capacidades") ? <FaRegStar /> : <FaStar style={{ color: 'orange' }} />}</button>
                    <span style={{ fontWeight: '500' }}>Árvore de Capacidades</span>
                </h2>
                <Form.Select style={{ width: '200px', marginRight: '15px' }} value={tipoCapacidade} onChange={(e) => setTipoCapacidade(e.target.value)} size="sm">
                    <option value="1">Forças</option>
                    <option value="2">Fraquezas</option>
                    <option value="3">Oportunidades</option>
                    <option value="4">Ameaças</option>
                </Form.Select>
            </div>
            <div style={{ width: '100%', height: '70vh' }}>
                <style>
                    {SAMPLE_CSS}
                </style>
                {isLoading ?
                    <Skeleton variant="rounded" width="100%" height={350} />
                    :
                    <>
                        <div className="content-wrapper" style={{ width: "100%" }}>
                            <div>
                                <ToolbarComponent ref={(toolbar) => (toolbarEditor = toolbar)} id="toolbar_diagram" clicked={handleToolbarClick}>
                                    <ItemsDirective>
                                        <ItemDirective id='ZoomIn' prefixIcon="e-icons e-zoom-in" tooltipText="Zoom In" />
                                        <ItemDirective id='ZoomOut' prefixIcon="e-icons e-zoom-out" tooltipText="Zoom Out" />
                                        <ItemDirective id='Separator1' type="Separator" />
                                        <ItemDirective id='Select' prefixIcon="e-icons e-mouse-pointer" tooltipText="Select" />
                                        <ItemDirective id='PanTool' prefixIcon="e-icons e-pan" tooltipText="Pan Tool" />
                                        <ItemDirective id='Separator2' type="Separator" />
                                        <ItemDirective id='Reset' prefixIcon="e-icons e-reset" tooltipText="Reset" />
                                        <ItemDirective id='FitToPage' prefixIcon="e-icons e-zoom-to-fit" tooltipText="Fit To Page" />

                                    </ItemsDirective>
                                </ToolbarComponent>
                            </div>
                        </div>
                        <DiagramComponent ref={(diagram) => (diagramInstance = diagram)} snapSettings={{ constraints: SnapConstraints.None }} id={`${tab}-arvore`} width={"100%"} height={"90%"} scrollSettings={{ scrollLimit: "Diagram" }} dataSourceSettings={dataSettings} layout={layoutSetting} getNodeDefaults={(node) => {
                            node.width = 300;
                            node.height = 70;
                            let cor = ""
                            let corTipo = ""
                            if (node.data.tipoSwot == "Forca") {
                                cor = '#d0ecab'
                                corTipo = "#0F6631"
                            } else if (node.data.tipoSwot == "Fraqueza") {
                                cor = '#FFC5BD'
                                corTipo = "#661612"
                            } else if (node.data.tipoSwot == "Oportunidade") {
                                cor = '#addbff'
                                corTipo = "#002851"
                            } else if (node.data.tipoSwot == "Ameaca") {
                                cor = '#FEF9C3'
                                corTipo = "#713F12"
                            } else if (node.data.tipo == "Sistema") {
                                cor = '#D5A9FF'
                                corTipo = "#5E1670"
                            }
                            else {
                                cor = '#FFD4B1'
                                corTipo = "#A84D2C"
                            }
                            let style =
                                `
                                    display: flex;
                                    flex-direction: column;
                                    height: 100%;
                                    width: 100%;
                                    border: 3px solid;
                                    border-color: ${cor};
                                    border-radius: 5px;
                                `

                            let styleTipo =
                                `
                                    background:${cor};
                                    font-size: 12px;
                                    padding: 0px 5px;
                                    border-radius: 2px;
                                    color: ${corTipo};
                                `

                            let styleDescricao = `
                                    padding: 5px;
                                `
                            node.shape = {
                                type: 'HTML',
                                content: `<div style="${style}">
                                            <div style="padding: 2px 4px;"><span style="${styleTipo}">${node.data.tipo}</span></div>
                                            <p style="${styleDescricao}">${node.data.titulo}</p>
                                        </div>`,
                            }

                            return node;
                        }}
                            tool={
                                DiagramTools.ZoomPan
                            }
                            getConnectorDefaults={(connector) => {
                                connector.type = "Orthogonal";
                                connector.cornerRadius = 7;
                                connector.targetDecorator.height = 0;
                                connector.targetDecorator.width = 0;
                                connector.style.strokeColor = "#ccc"
                                connector.style.strokeWidth = 3
                                connector.direction = "Right";
                                return connector;
                            }}>
                            <Inject services={[HierarchicalTree, DataBinding]} />
                        </DiagramComponent>
                    </>
                }
            </div>
        </>
    )
}